<script>
import Vuescroll from 'vuescroll';

import CardSection from "@/components/atoms/CardSection";
import PartCard from "@/components/atoms/PartCard";
import CardsLoadingSpinner from "@/components/atoms/CardsLoadingSpinner";

const MAX_CARDS = 3;

export default {
  components: { CardSection, PartCard, Vuescroll, CardsLoadingSpinner },
  mounted(){
    // this.$gtag.event('view_categories', {'event_category': 'flow'});
  },
  data() {
    return {
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false
        },
        rail: {
          size: "20px"
        },
        bar: {
          size: "12px",
          background: "#666"
        }
      }
    }
  },
  computed: {
    categoriesLegend(){
      return this.$store.get("parts/categoriesLegend");
    },
    categories(){
      if(this.$route.params.part_category && this.$store.get("parts/categoryById", this.$route.params.part_category)){
        return this.$store.get("parts/categoryById", this.$route.params.part_category).children.filter(child => (
          !child.match(/S_[0-9]+/g) && 
          child.toLowerCase() != "metric" && 
          child.toLowerCase() != "fractional" &&
          child.toLowerCase() != "imperial"
        ))
      }else{
        return this.categoriesLegend
      }
    },
    category(){
      // this.$gtag.event('view_category', {'event_category': 'flow', 'event_label': this.$route.params.part_category});
      return this.$store.get("parts/categoryById", this.$route.params.part_category)
    }
  },
  methods: {
    limitedPartsByCategory(category) {
      return this.$store.get("parts/partsByCategory", category)
    },
    goToCategory(categoryId){
      if(this.$route.fullPath.includes("parts/categories")){
        this.$router.push((this.$route.fullPath+"/"+categoryId).replace("//", "/"))
      }else{
        this.$router.push((this.$route.fullPath+"/parts/categories/"+categoryId).replace("//", "/"))
      }
    },
    goBack(){
      this.$router.push(this.$route.fullPath.substr(0, this.$route.fullPath.lastIndexOf(this.category.id)))
    }
  },
};
</script>

<template>
  <div id="categories">

    <div class="header" v-if="!category || ($store.get('search_filter') && $store.get('search_filter').length > 1)">
      All Parts
    </div>
    <div class="category-title-area" @click="goBack" v-else>
      <div class="back">
        <i class="fas fa-chevron-left fa-sm"></i> Back
      </div>
      <div class="category-title">
        {{ category.name }} <span class="count">{{$store.get('parts/getPartsCount', category)}}</span>
      </div>
    </div>
    <div class="card-section" v-if="$store.get('parts/partsLoading')">
      <div class="card-row">
        <CardsLoadingSpinner size="small"/>
      </div>
    </div>
    <div v-if="!$store.get('search_filter') || $store.get('search_filter').length <= 1">
      <div v-if="categories.length > 0">
        <div class="card-section" v-for="(categoryId, index) in categories" :key="index+'-'+categoryId" v-if="$store.get('parts/partsByCategoryUnfiltered', $store.get('parts/categoryById', categoryId)).length > 0">
          <div class="section-title-area" @click="goToCategory(categoryId)">
            <div class="section-title">
              {{ $store.get("parts/categoryById", categoryId).name }} <span class="count">{{$store.get('parts/getPartsCount', $store.get('parts/categoryById', categoryId))}}</span>
            </div>
            <div class="view-all">View All</div>
          </div>
          <div class="scroll-container" :class="{['has-cards']: limitedPartsByCategory($store.get('parts/categoryById', categoryId)).length > 0}">
            <Vuescroll :ops="ops">
              <div class="card-row">
                <PartCard
                  v-for="(part, part_index) in limitedPartsByCategory($store.get('parts/categoryById', categoryId))" v-if="part_index < 10"
                  :key="index+'-'+part_index+'-'+part.id"
                  :part="part"
                  :link="('/part/'+part.id).replace('//', '/')"
                />
                <div class="card" @click="$router.push('/parts/categories/'+categoryId)">
                  View All
                </div>
                <div class="spacer"><br></div>
              </div>
            </Vuescroll>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="card-section">
          <div class="card-area">
            <PartCard
              v-for="(part, part_index) in $store.get('parts/partsByCategory', category)"
              :key="part_index + '-' +part.id"
              :part="part"
              :link="('/part/'+part.id).replace('//', '/')"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card-section">
        <div class="card-area">
          <PartCard
            v-for="(part, part_index) in $store.get('parts/parts')"
            :key="part_index + '-' +part.id"
            :part="part"
            :link="('/part/'+part.id).replace('//', '/')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/styles/constants";
#categories{
  margin-top: 1rem;
  .header{
    font-size: 2.5rem;
    padding: 1rem 3rem;
  }
}
.category-title-area {
  display: inline-block;
  margin: 1rem 2rem;
  padding: 0.5rem 1rem;
  position: relative;
  border-radius: 0.5rem;
  &:hover, &.hover {
    background-color: $black_2;
    .back{
      top: 1.75rem;
      font-size: 2rem;
    }
    .category-title{
      opacity: 0;
    }
  }
  * {
    pointer-events: none;
  }
  .back{
    position: absolute;
    top: 1rem;
    left: 1.5rem;
    font-size: 1.25rem;
    padding-bottom: 0.25rem;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    i{
      margin-right: 0.5rem;
    }
  }
  .category-title {
    padding-top: 2rem;
    font-size: 2.25rem;
    opacity: 1;
    transition: all 0.3s ease;
    .count{
      font-size: 2rem;
      margin-left: 0.5rem;
      color: #888;
    }
    i{
      margin-right: 0.5rem;
    }
  }
  .view-all {
    font-size: 1rem;
  }
}
.card-section {
  border-bottom: 3px solid $black_2;
  .section-title-area {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: 1.5rem 3rem 1.25rem 3rem;
    &:hover, &.hover {
      background-color: $black_2;
    }
    * {
      pointer-events: none;
    }
    .section-title {
      font-size: 1.5rem;
      margin-right: 1rem;
      .count{
        margin-left: 0.25rem;
        color: #888;
      }
    }
    .view-all {
      font-size: 1.25rem;
      color: #888;
    }
  }
}
.card-row{
  display: flex;
  flex-wrap: nowrap;
  align-items: center;  
  justify-content: flex-start;
  padding: 0rem 2rem;
  margin: auto;
  .spacer{
    min-width: 1rem;
  }
  .card{
    width: 24rem;
    height: 26rem;
    min-width: 24rem;
    min-height: 26rem;
    margin: 0.75rem;
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $card_background;
    box-shadow: $z_depth_2;
    transition: transform 0.3s ease;
    border-radius: 0.5rem;
    position: relative;
    &:hover, &.hover{
      transform: scale(1.025);
      cursor: pointer;
      .grab-indicator{
        // opacity: 1;
      }
    }
  }
}
.scroll-container{
  &.has-cards{
    height: 30rem;
  }
}
</style>